import { useQuery } from "react-query";
import { scheduleDraftQueryKeys } from "./queryKeys";
import { scheduleDraftDataService } from "../services/scheduleDraftDataService";

export function useScheduleDraftAgentSessions(draftId, options = {}) {
    return useQuery(
        scheduleDraftQueryKeys.agentSessions(draftId),
        () => scheduleDraftDataService.getAgentSessions(draftId),
        {
            enabled: Boolean(draftId),
            staleTime: 15000,
            refetchOnWindowFocus: false,
            ...options,
        },
    );
}

export default useScheduleDraftAgentSessions;
